/**
 * Handle link preload, using event emmiter
 */
import eventEmitterInstance from 'Lib/utils/emitter';

export const PRELOAD_EVENT_LOAD = 'preload/load';
export const eventEmitter = eventEmitterInstance;
export const preloadLink = (path: string, cb: () => void) => {
  eventEmitter.emit(PRELOAD_EVENT_LOAD, path, cb);
};
